import React from "react";
import portfolio02 from "../img/portfolio02.web.app.png";
import portfolio03 from '../img/HelloWorld_slide.png';

class Works extends React.Component {
  render() {
    return (
      <div id="works">
        <h1 className="title">Works</h1>
        <div id="container">
          <ul>
            <li>
              <p>HTML & CSS & jQuery</p>
              <p>『"Hello World"』</p>
              <img src={portfolio02} alt="スクショ" />
              <p className="discription">
                HTMLとCSSとjQueryで作成しました。
                <br />
                季節の移り変わりがテーマです。
              </p>
              <a href="https://portfolio02.web.app/" target="_blank" rel="noopener noreferrer" >LINK</a>
            </li>
            <li>
              <p>HTML & CSS & jQuery</p>
              <p>『"Hello World"』</p>
              <img
                src={portfolio03}
                alt="スクショ"
              />
              <p className="discription">
              HTMLとCSSとjQueryで作成しました。
              <br />
              メインテーマはネオンです。
              </p>
              <a href="https://portfolio3-2d24a.firebaseapp.com/" target="_blank" rel="noopener noreferrer" >LINK</a>
            </li>
            <li>
              <p>Coming soon</p>
              <p>???</p>
              <img
                src="https://placehold.jp/454545/ffffff/300x150.png?text=?"
                alt="スクショ"
              />
              <p className="discription">
                ???????
              </p>
              <a href="/">LINK</a>
            </li>
            <li>
              <p>Coming soon</p>
              <p>???</p>
              <img
                src="https://placehold.jp/454545/ffffff/300x150.png?text=?"
                alt="スクショ"
              />
              <p className="discription">
                ???????
              </p>
              <a href="/">LINK</a>
            </li>
            <li>
              <p>Coming soon</p>
              <p>???</p>
              <img
                src="https://placehold.jp/454545/ffffff/300x150.png?text=?"
                alt="スクショ"
              />
              <p className="discription">
                ???????
              </p>
              <a href="/">LINK</a>
            </li>
            <li>
              <p>Coming soon</p>
              <p>???</p>
              <img
                src="https://placehold.jp/454545/ffffff/300x150.png?text=?"
                alt="スクショ"
              />
              <p className="discription">
                ???????
              </p>
              <a href="/">LINK</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Works;
